import React from "react";
import { List, Icon, Tooltip } from "antd";
import moment from "moment";
import { useRouteMatch } from "react-router-dom";

import IconText from "./icon-text";
import stateIcon from "../../../components/state-icon/state-icon";

const ListItem = ({ item }) => {
	const match = useRouteMatch("/Voting/:id") || { params: {} };
	const {
		params: { id },
	} = match;
	const createDate = moment(item.createDate).format("DD.MM.YY HH:mm");
	const dateStart = moment(item.dateStart).format("DD.MM.YY HH:mm");
	const dateStop = moment(item.dateStop).format("DD.MM.YY HH:mm");
	return (
		<List.Item
			key={item.id}
			className={`list-item ${
				item.id === Number(id) ? "list-item-active" : ""
			}`}
		>
			<List.Item.Meta
				title={
					<div className="header">
						<div className="title">{item.title}</div>
					</div>
				}
				description={<div className="company">{item.serviceCompany}</div>}
			/>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<div className="status">
					<Tooltip
						placement="right"
						title={
							item.state.name === "Активное" ? "Активный" : item.state.name
						}
					>
						{stateIcon[item.state?.id]}
					</Tooltip>
				</div>
				<div className="period">
					{dateStart} - {dateStop}
				</div>
			</div>
			<div className="additional-info">
				<IconText
					text={<span className="item-id">{item.id}</span>}
					key="list-vertical-star-o"
					tip="ID опроса"
				/>
				<div className="divider" />

				<IconText
					type="calendar-o"
					text={createDate}
					key="list-vertical-like-o"
					tip="Время создания"
				/>
			</div>
		</List.Item>
	);
};

export default ListItem;
